import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Welcome from '../components/Welcome.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    meta: { title: 'Covid Data Explorer - Home'},
    children: [
      {
        path: '/',
        name: 'Welcome',
        meta: { title: 'Covid Data Explorer'},
        component: Welcome
      },
      {
        path: '/states/:state',
        name: 'State',
        meta: { title: 'Covid Data Explorer'},
        component: () => import(/* webpackChunkName: "about" */ '../components/State.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
